(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-bhs-header]').forEach((header) => {
      if (header.dataset.initialized) return;
      header.dataset.initialized = 'true';
      const toggle = header.querySelector('[data-bhs-menu-toggle]');
      const nav = header.querySelector('.bhs-nav');
      const brand = header.querySelector('.bhs-brand');
      const actions = header.querySelector('.bhs-header__actions');
      const dialog = header.querySelector('[data-bhs-search-dialog]');
      const desktop = matchMedia('(min-width: 1200px)');
      const closeMenu = (restore = false) => {
        delete header.dataset.menuOpen;
        toggle?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('bhs-menu-open');
        if (brand) brand.inert = false;
        if (actions) actions.inert = false;
        header.querySelectorAll('details[open]').forEach((details) => details.open = false);
        if (restore) toggle?.focus();
      };
      toggle?.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') closeMenu(true);
        else {
          header.dataset.menuOpen = 'true';
          toggle.setAttribute('aria-expanded', 'true');
          document.body.classList.add('bhs-menu-open');
          if (brand) brand.inert = true;
          if (actions) actions.inert = true;
          nav?.querySelector('a, summary')?.focus();
        }
      });
      header.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeMenu(true);
        if (event.key !== 'Tab' || desktop.matches || !header.dataset.menuOpen) return;
        const nodes = [toggle, ...nav.querySelectorAll('a,summary')].filter((node) => node && node.getClientRects().length);
        const index = nodes.indexOf(document.activeElement);
        event.preventDefault();
        nodes[(index + (event.shiftKey ? -1 : 1) + nodes.length) % nodes.length]?.focus();
      });
      header.querySelectorAll('.bhs-nav__disclosure').forEach((details) => details.addEventListener('toggle', () => {
        if (details.open) header.querySelectorAll('.bhs-nav__disclosure').forEach((other) => { if (other !== details) other.open = false; });
      }));
      nav?.addEventListener('click', (event) => { if (event.target.closest('a')) closeMenu(); });
      document.addEventListener('click', (event) => { if (!header.contains(event.target)) closeMenu(); });
      desktop.addEventListener('change', () => closeMenu());
      header.querySelector('[data-bhs-search-open]')?.addEventListener('click', (event) => {
        if (!dialog?.showModal) return;
        event.preventDefault();
        closeMenu();
        dialog.showModal();
        dialog.querySelector('input[type="search"]')?.focus();
      });
      header.querySelector('[data-bhs-search-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('bhs-menu-open'));
})();
